import { Injectable } from '@angular/core';
import { ClientService } from './client.service';
import { ModelFactory } from '../models/model-factory';
import { ZoneModel } from '../models/zone-model';

@Injectable({
  providedIn: 'root',
})
export class ZoneService {
  constructor(private client: ClientService) {}

  async getZones(): Promise<Array<ZoneModel>> {
    return ModelFactory.newInstances(ZoneModel, await this.client.get('api/zones'));
  }
}
